export const approveonboardingBusinessInfo = (state) => state.approvebusinessInfoReducer.businessInfoSuccess;
export const approveonboardingBusinessInfoErrorSaga = (state) => state.approvebusinessInfoReducer.businessInfoError;
